
















import FilterCard from './FilterCard.vue';
import {defineComponent} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: 'ScopeLinks',
  components: {
    FilterCard
  },
  setup: () => {
    const {filteredScopeLinks} = useGetters('scope', ['filteredScopeLinks'])

    return {
      filteredScopeLinks
    }
  }
})
